module.exports = __webpack_public_path__ + "static/media/remember-me-box.1ecaa9b4.svg";